// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__sm_ve","Icon":"Languages_Icon__39KzV","LanguagesSelect":"Languages_LanguagesSelect__1C_fF","minimalist":"Languages_minimalist__uRKKW"};